import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ApartmentIcon from "@mui/icons-material/Apartment";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import FaceIcon from "@mui/icons-material/Face";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AlignHorizontalLeftIcon from "@mui/icons-material/AlignHorizontalLeft";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AssessmentIcon from '@mui/icons-material/Assessment';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import SettingsIcon from '@mui/icons-material/Settings';
import { DI_APP_MODE, POS_APP_MODES } from "../Users/Variables";
import { REPORT_PATHS } from "../ledgerReports/reportCatalog";

// Items (and sub-items) carry an optional `modes` list: they are only shown to a
// user whose App Mode selection includes one of those modes. No `modes` = always shown.

// Whether an item is the one being shown: its own page, one of its sub-items,
// or one of the pages it opens (`matchPaths`, e.g. Reports).
export const isMenuItemActive = (item, subItems, pathname) =>
  pathname === item.path ||
  Boolean(subItems?.some((sub) => sub.path === pathname)) ||
  Boolean(item.matchPaths?.includes(pathname));

// Define your menu structure
export const menuItems = [
  {
    key: "admin-dashboard",
    title: "Admin Dashboard",
    icon: <AccountBalanceIcon />,
    tooltip: "View Admin Dashboard",
    path: "/main/admin-dashboard",
  },
  {
    key: "dashboard",
    title: "Dashboard",
    icon: <DashboardIcon />,
    tooltip: "View Dashboard",
    path: "/main",
  },
  {
    key: "hscode",
    title: "HS Code",
    icon: <LocalOfferIcon />,
    tooltip: "Here HS Code Data will be Managed",
    path: "/main/view-hscode",
    // subItems: [
    //   {
    //     title: "Add HS Code",
    //     tooltip: "Add New HS Code",
    //     path: "/main/add-hscode",
    //   },
    //   {
    //     title: "HS Code",
    //     tooltip: "View All HS Codes",
    //     path: "/main/view-hscode",
    //   },
    // ],
  },
  {
    key: "company",
    title: "Company",
    icon: <ApartmentIcon />,
    tooltip: "Here Company Data will be Managed",
    path: "",
    subItems: [
      {
        title: "Add Company",
        tooltip: "Add New Company",
        path: "/main/add-company",
      },
      {
        title: "Companies List",
        tooltip: "View Companies",
        path: "/main/view-company-list",
      },
    ],
  },
  {
    key: "items",
    title: "Items",
    icon: <ShoppingCartCheckoutIcon />,
    tooltip: "Here Items Details Will be Managed",
    path: "",
    subItems: [
      {
        title: "Add Item",
        tooltip: "Add New Item",
        path: "/main/add-item",
      },
      {
        title: "Items List",
        tooltip: "View Items",
        path: "/main/view-item-list",
      },
    ],
  },
  {
    key: "buyers",
    title: "Buyer",
    icon: <FaceIcon />,
    tooltip: "Here Buyers Details Will be Managed",
    path: "",
    subItems: [
      {
        title: "Add Buyer",
        tooltip: "Add New Buyer",
        path: "/main/add-buyer",
      },
      {
        title: "Buyers List",
        tooltip: "View Buyers",
        path: "/main/view-buyer-list",
      },
    ],
  },
  {
    key: "invoices",
    title: "Invoicing",
    icon: <ReceiptIcon />,
    tooltip: "Here Invoices Details Will be Managed",
    path: "",
    subItems: [
      {
        title: "Add Invoices",
        tooltip: "Add New Invoices",
        path: "/main/add-invoice",
        modes: [DI_APP_MODE],
      },
      {
        title: "Add POS Invoice",
        tooltip: "Add New POS Invoice",
        path: "/main/add-pos-invoice",
        modes: POS_APP_MODES,
      },
      {
        title: "Invoices List",
        tooltip: "View Invoices",
        path: "/main/view-invoice-list",
      },
      {
        title: "Bulk Invoice Uploader",
        tooltip: "Upload Bulk of Invoices",
        path: "/main/bulk-invoice-uploader",
      },
    ],
  },
  {
    key: "receiving",
    title: "Receiving",
    icon: <LocalShippingIcon />,
    tooltip: "Record goods received from suppliers",
    path: "",
    subItems: [
      {
        title: "Add Receiving",
        tooltip: "Record New Goods Received",
        path: "/main/add-receiving",
      },
      {
        title: "Receivings List",
        tooltip: "View Receivings",
        path: "/main/view-receiving-list",
      },
    ],
  },
  {
    // Every report and ledger, as boxes on one page (ledgerReports/Index.jsx).
    // The reports keep their own URLs; `matchPaths` keeps this item
    // highlighted while one of them is open.
    key: "reports",
    title: "Reports",
    icon: <AssessmentIcon />,
    tooltip: "Ledgers, invoice reports and the stock report",
    path: "/main/reports",
    matchPaths: REPORT_PATHS,
  },
  {
    key: "fbr-testing",
    title: "FBR Scenerio Testing",
    icon: <AlignHorizontalLeftIcon />,
    tooltip: "Here FBR Scenerio Testing Will be Done",
    path: "/main/fbr-scenerio-testing",
  },
  {
    key: "users",
    title: "Users",
    icon: <ManageAccountsIcon />,
    tooltip: "Here Users Details Will be Managed",
    path: "",
    subItems: [
      {
        title: "Add User",
        tooltip: "Add New User",
        path: "/main/add-user",
      },
      {
        title: "Users List",
        tooltip: "View Users",
        path: "/main/view-user-list",
      },
      {
        title: "Admin Scenerio Testing",
        tooltip: "View Admin FBR Scenerio Testing",
        path: "/main/user-fbrscenerio-testing",
      },
      {
        title: "Post Default Production Invoice",
        tooltip: "Post Default Production Invoices For All Users Here...",
        path: "/main/post-production-invoice",
      }
    ],
  },
  {
    key: "subscriptions",
    title: "Subscription",
    icon: <CardMembershipIcon />,
    tooltip: "View subscription status and renewals",
    path: "/main/subscriptions",
  },
  {
    // Everyone can search the list; uploading the file is a tab only an
    // administrator gets (Screens/Atl/Index.jsx).
    key: "atl",
    title: "Active Taxpayers",
    icon: <FactCheckIcon />,
    tooltip: "Search FBR's Active Taxpayer List",
    path: "/main/active-taxpayers",
  },
  {
    // Administrators only (Header.js hides it from everyone else).
    key: "program-settings",
    title: "Program Settings",
    icon: <SettingsIcon />,
    tooltip: "Tools for administrators, such as updating every buyer's status",
    path: "/main/program-settings",
  },
];
